import * as Helper from "../../constants/reducer_names";
import AgentTrackerReducers from "../slices/trackerStatus_slice/agentTrackerslice";
import AgentstatusListReducer from "../slices/agent-status/agent-status";
import AgentStateReducer from "../slices/agent-status/agent_state";
import BusinessHoursReducer from "../slices/business_hours_slice/business_hours_slice";
import ChatConfigurationReducer from "../slices/chat_configuration_slice/chat_configuration_slice";
import ChatReducer from "../slices/chat_slice/chat_slice";
import ContactCenterNumber from "../slices/contact_center_number_slice/contact_center_number";
import CustomQueueReducer from "../slices/custom_queue_slice/custom_queue_slice";
import CustomerTagReducer from "../slices/customerTag_slice/createCustomerTag";
import DeleteCustomerTagReducer from "../slices/customerTag_slice/deleteCustomerTag";
import EditManageMent from "../slices/user_management/edit_user";
import ForgotPasswordReducer from "../slices/authentication_slice/forgot_password_slice";
import GetAllRoutingReducer from "../slices/routing_profile/get_routing_profile_list";
import GetCustomerTagReducer from "../slices/customerTag_slice/getCustomerTag";
import IsValidCustomerTagReducer from "../slices/customerTag_slice/isValidCustomerTag";
import LoginUserReducer from "../slices/authentication_slice/login_slice";
import NodeFlowReducer from "../slices/node_flow_slice/node_flow_slice";
import MetaTemplatesReducer from "../slices/meta_templates_slice/meta_templates_slice";
import NotificationReducer from "../slices/main_layout_slice/notification";
import PlayPrompt from "../slices/playPromptSlice/play_prompt_slice";
import QueueTrackerReducers from "../slices/trackerStatus_slice/queueTrackerslice";
import ReportsDataSliceReducer from "../slices/analytics_slice/graphsData";
import ResetLinkReducer from "../slices/authentication_slice/reset_link_slice";
import SidebarReducer from "../slices/main_layout_slice/sidebar_slice";
import StandAloneBot from "../slices/standAloneBot_slice/reportstandAlone_slice";
import SkillmanagementReducer from "../slices/Skill_slice/skillsettings";
import UpdateCustomerTagReducer from "../slices/customerTag_slice/updateCustomerTag";
import UserInformationReducer from "../slices/user_slice/user_information_slice";
import UserList from "../slices/user_management/get_all_users";
import UserListDetails from "../slices/user_management/get_user_details";
import UserManageMentHelpers from "../slices/user_management/user_management_need";
import UserSettingsReducer from "../slices/settings_slice/user_settings_slice";
import callPopUpAgnet from "../slices/voice_call_slice/call_popup_agent";
import callUserAgnetDetails from "../slices/voice_call_slice/login_user_call_details";
import coChatDetailsReducer from "../slices/cochat_slice/cochat_channel_details_slice";
import coChatReducer from "../slices/cochat_slice/cochat_channels_slice";
import coChatUserDetailsReducer from "../slices/cochat_slice/cochat_user_details_slice";
import contactList from "../slices/agnetWorkspaceContactslice/contactsSlice";
import reportsCallReducer from "../slices/reports_file/answered_call_report";
import dispositionStatusReducer from "../slices/dispositionSlice/postDisposition";
import { emailConfigSliceReducer } from "../slices/email_config/email_config";
import { shortcutKeysReducer } from "../slices/shortcutkeys_slice/shortcutkeys_slice";
import smsListReducer from "../slices/sms/sms";
import { supervisorContactDataSliceReducer } from "../slices/supervisor_contact/contactsData";
import { agentAnalyticsWebchatSliceReducer } from "../slices/analytics/agentanalytics/agentAnalyticsWebchatSlice";
import internalChatReducer from "../slices/chat_slice/internalChat_slice";
import dashBoardReducer from "../slices/dashboard_slice/dashBoard";
import { allActivityReducers } from "../slices/all_activity_slice/all_activity_slice";
import { newEmailEntriesSliceReducer } from "../slices/new_emailEntries/newEmailEntries"
import getAllQAList from "../slices/question_answer_slice/questionanswer"
import knowledgeBaseTab from "../slices/knowledgebasebot/knowledgebot";
import connectorSlice from "../slices/connectors/connectors_slice";
import liveTracker from '../slices/live_tracker/'
// import  newEmailEntriesSliceReducer  from "../slices/new_emailEntries/newEmailEntries";
import apiIntegration_slice from "../slices/apiIntegration/apiIntegration_slice";
import callConfig from "../slices/voice_call_slice/callConfig";
import whatsapp_config from "../slices/whatsapp_config";
import facebook_config from "../slices/facebook_config";
import socialmediaWidget from "../slices/socialmediaWidget";
import  meetingReducer from "../slices/meet_slice/meetslice";
import storeVideoSliceReducer from '../slices/storeVideo/storeVideoData'
import mediaslice from "../slices/mediaslices/mediaslice";
// import userAgent from "../slices/userAgent/videocalluseragent";
import screenshare from "../slices/screenshare_slice/screensharedata"
import closeCaption from "../slices/cc_slice/cc_slice";
import { agentAnalyticsEmailSliceReducer } from "../slices/analytics/agentanalytics/agentAnalyticsEmailSlice";
import { agentAnalyticsVoiceSliceReducer } from "../slices/analytics/agentanalytics/agentAnalyticsVoiceSlice";
import { agentAnalyticsSMSSliceReducer } from "../slices/analytics/agentanalytics/agentAnalyticsSMSSlice";
import { agentAnalyticsWhatsAppSliceReducer } from "../slices/analytics/agentanalytics/agentAnalyticsWhatsappSlice";
import { agentAnalyticsFacebookSliceReducer } from "../slices/analytics/agentanalytics/agentAnalyticsFacebookSlice";
import { agentAnalyticsInstagramReducer } from "../slices/analytics/agentanalytics/agentAnalyticsInstagramSlice";
import { queueAnalyticsVoiceSliceReducer } from "../slices/analytics/queueanalytics/queueAnalyticsVoiceSlice";
import { queueAnalyticsWebchatSliceReducer } from "../slices/analytics/queueanalytics/queueAnalyticsWebchatSlice";
import { queueAnalyticsSocialMediaSliceReducer } from "../slices/analytics/queueanalytics/queueAnalyticsSocialMediaSlice";
import { VirtualBG } from "../../base/reducer/virtualBG";
import CustomerSatisfactionReducer from "../slices/customer_satisfaction_slice/customer_satisfaction-slice";
import DynamicdDashboardReducer from "../slices/dynamicDash_slice/index";
import OutboundCampaignReducer from"../slices/outboundCampaign/outboundCampaignslice";

export const LoginUserReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.LOGIN_USER}/reset`) {
    state = undefined;
  }
  return LoginUserReducer(state, action);
};

export const ForgotPasswordReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.FORGOT_PASSWORD}/reset`) {
    state = undefined;
  }
  return ForgotPasswordReducer(state, action);
};

export const BusinessHoursReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.BUSINESS_HOURS}/reset`) {
    state = undefined;
  }
  return BusinessHoursReducer(state, action);
};

export const ResetLinkReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.RESET_LINK}/reset`) {
    state = undefined;
  }
  return ResetLinkReducer(state, action);
};

export const UserInformationReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.RESET_LINK}/reset`) {
    state = undefined;
  }
  return UserInformationReducer(state, action);
};

export const UserSettingsReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.USER_SETTINGS}/reset`) {
    state = undefined;
  }
  return UserSettingsReducer(state, action);
};
export const agentstatusListReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.AGENT_STATUS}/reset`) {
    state = undefined;
  }
  return AgentstatusListReducer(state, action);
};
export const agentstateReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.AGENT_STATE}/reset`) {
    state = undefined;
  }
  return AgentStateReducer(state, action);
};

export const UserListReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.ALL_USER_LIST}/reset`) {
    state = undefined;
  }
  return UserList(state, action);
};

export const CreateCustomerTagReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CUSTOMER_TAG}/reset`) {
    state = undefined;
  }
  return CustomerTagReducer(state, action);
};

export const GetCustomerTagReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.GET_CUSTOMER_TAG}/reset`) {
    state = undefined;
  }
  return GetCustomerTagReducer(state, action);
};

export const UpdateCustomerTagReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.UPDATE_CUSTOMER_TAG}/reset`) {
    state = undefined;
  }
  return UpdateCustomerTagReducer(state, action);
};

export const DeleteCustomerTagReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.DELETE_CUSTOMER_TAG}/reset`) {
    state = undefined;
  }
  return DeleteCustomerTagReducer(state, action);
};

export const allActivityReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.ALL_ACTIVITY}/reset`) {
    state = undefined;
  }
  return allActivityReducers(state, action);
};

export const IsValidCustomerTagReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.IS_VALID_CUSTOMER_TAG}/reset`) {
    state = undefined;
  }
  return IsValidCustomerTagReducer(state, action);
};
export const skillmanagementReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SKILL_MANAGEMENT}/reset`) {
    state = undefined;
  }
  return SkillmanagementReducer(state, action);
};

export const QueueTrackerReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.QUEUE_TRACKER_DATA}/reset`) {
    state = undefined;
  }
  return QueueTrackerReducers(state, action);
};

export const AgentTrackerReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.AGENT_TRACKER_DATA}/reset`) {
    state = undefined;
  }
  return AgentTrackerReducers(state, action);
};
export const SidebarWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SIDE_BAR}/reset`) {
    state = undefined;
  }
  return SidebarReducer(state, action);
};

export const NotificationWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SIDE_BAR}/reset`) {
    state = undefined;
  }
  return NotificationReducer(state, action);
};

export const playPromptReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.PLAY_PROMPT_DATA}/reset`) {
    state = undefined;
  }
  return PlayPrompt(state, action);
};

export const reportCallAnsweredWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.REPORT_CALL_ANSWERED}/reset`) {
    state = undefined;
  }
  return reportsCallReducer(state, action);
};

export const shortcutKeysReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SHORTCUTKEYS}/reset`) {
    state = undefined;
  }
  return shortcutKeysReducer(state, action);
};

export const UserDetailsReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.USER_DETAILS}/reset`) {
    state = undefined;
  }
  return UserListDetails(state, action);
};

export const userManagementHelpersWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.USER_HELPER}/reset`) {
    state = undefined;
  }
  return UserManageMentHelpers(state, action);
};

export const EditUserManagerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.EDIT_USER_DETAILS}/reset`) {
    state = undefined;
  }
  return EditManageMent(state, action);
};
export const RoutingListReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.ALL_ROUTING_PROFILE_LIST}/reset`) {
    state = undefined;
  }
  return GetAllRoutingReducer(state, action);
};

export const ContactCenterNumberReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CONTACT_CENTER_NUMBER}/reset`) {
    state = undefined;
  }
  return ContactCenterNumber(state, action);
};

export const AnalyticsChartsWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.REPORTS_DATA}/reset`) {
    state = undefined;
  }
  return ReportsDataSliceReducer(state, action);
};

export const supervisorContactWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SUPERVISOR_CONTACT_DATA}/reset`) {
    state = undefined;
  }
  return supervisorContactDataSliceReducer(state, action);
};

export const CustomQueueReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CUSTOM_QUEUE}/reset`) {
    state = undefined;
  }
  return CustomQueueReducer(state, action);
};

export const NodeFlowReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.NODE_FLOW}/reset`) {
    state = undefined;
  }
  return NodeFlowReducer(state, action);
};

export const MetaTemplatesReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.META_TEMPLATES}/reset`) {
    state = undefined;
  }
  return MetaTemplatesReducer(state, action);
};

export const ChatConfigurationReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CHAT_CONFIGURATION}/reset`) {
    state = undefined;
  }
  return ChatConfigurationReducer(state, action);
};

export const ChatReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CHAT_REDUCER}/reset`) {
    state = undefined;
  }
  return ChatReducer(state, action);
};
export const MeetReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.MEET_REDUCER}/reset`) {
    state = undefined;
  }
  return meetingReducer(state, action);
};

export const VBGReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.VBG_REDUCER}/reset`) {
    state = undefined;
  }
  return VirtualBG(state, action);
};

export const CaptionReducerWrapper=(state: any, action: any)=>{
  if (action.type === `${Helper.CLOSE_CAPTION}/reset`) {
    state = undefined;
  }
  return closeCaption(state, action);
}
// export const videoAgentWrapper = (state: any, action: any) => {
//   if (action.type === `${Helper.VIDEO_USER_AGENT}/reset`) {
//     state = undefined;
//   }
//   return userAgent(state, action);
// };
export const StoreVideoReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.STORE_VIDEO_REDUCER}/reset`) {
    state = undefined;
  }
  return storeVideoSliceReducer(state, action);
};
export const CallUserAgentReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CALL_USER_AGENT_REDUCER}/reset`) {
    state = undefined;
  }

  return callUserAgnetDetails(state, action);
};

export const CallPOpUpAgnetModelWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.POPUP_CALLS}/reset`) {
    state = undefined;
  }
  return callPopUpAgnet(state, action);
};
export const ContactListModelWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.ALL_CONTACT_LIST}/reset`) {
    state = undefined;
  }
  return contactList(state, action);
};

export const smsModelWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SMS}/reset`) {
    state = undefined;
  }
  return smsListReducer(state, action);
};

export const coChatWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CO_CHAT}/reset`) {
    state = undefined;
  }
  return coChatReducer(state, action);
};

export const coChatDetailsWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CO_CHAT_DETAILS}/reset`) {
    state = undefined;
  }
  return coChatDetailsReducer(state, action);
};

export const coChatUserDetailsReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CO_CHAT_USER_DETAILS}/reset`) {
    state = undefined;
  }
  return coChatUserDetailsReducer(state, action);
};

export const dispositionStatusWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.DISPOSITION_STATUS}/reset`) {
    state = undefined;
  }
  return dispositionStatusReducer(state, action);
};

export const emailConfigWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.EMAIL_CONFIG}/reset`) {
    state = undefined;
  }
  return emailConfigSliceReducer(state, action);
};

export const internalChatWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.INTERNAL_CHAT}/reset`) {
    state = undefined;
  }
  return internalChatReducer(state, action);
};

export const dashBoardWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.DASH_BOARD}/reset`) {
    state = undefined;
  }
  return dashBoardReducer(state, action);
};

export const queueAnalyticsVoiceWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.VOICE_QUEUE_ANALYTICS}/reset`) {
    state = undefined;
  }
  return queueAnalyticsVoiceSliceReducer(state, action);
};

export const queueAnalyticsWebchatWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.WEBCHAT_QUEUE_ANALYTICS}/reset`) {
    state = undefined;
  }
  return queueAnalyticsWebchatSliceReducer(state, action);
};

export const queueAnalyticsSocialMediaWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SOCIALMEDIA_QUEUE_ANALYTICS}/reset`) {
    state = undefined;
  }
  return queueAnalyticsSocialMediaSliceReducer(state, action);
};

export const agentAnalyticsWebchatWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.WEBCHAT_AGENT_ANALYTICS}/reset`) {
    state = undefined;
  }
  return agentAnalyticsWebchatSliceReducer(state, action);
};

export const agentAnalyticsEmailWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.EMAIL_AGENT_ANALYTICS}/reset`) {
    state = undefined;
  }
  return agentAnalyticsEmailSliceReducer(state, action);
};

export const agentAnalyticsVoiceWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.VOICE_AGENT_ANALYTICS}/reset`) {
    state = undefined;
  }
  return agentAnalyticsVoiceSliceReducer(state, action);
};

export const agentAnalyticsSMSWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SMS_AGENT_ANALYTICS}/reset`) {
    state = undefined;
  }
  return agentAnalyticsSMSSliceReducer(state, action);
};

export const agentAnalyticsWhatsAppWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.WHATSAPP_AGENT_ANALYTICS}/reset`) {
    state = undefined;
  }
  return agentAnalyticsWhatsAppSliceReducer(state, action);
};

export const agentAnalyticsFacebookWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.FACEBOOK_AGENT_ANALYTICS}/reset`) {
    state = undefined;
  }
  return agentAnalyticsFacebookSliceReducer(state, action);
};

export const agentAnalyticsInstagramWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.INSTAGRAM_AGENT_ANALYTICS}/reset`) {
    state = undefined;
  }
  return agentAnalyticsInstagramReducer(state, action);
};

export const newEmailWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.EMAIL_ENTRIES}/reset`) {
    state = undefined;
  }
  return newEmailEntriesSliceReducer(state, action)
}
export const qaBotsettings = (state: any, action: any) => {
  if (action.type === `${Helper.QA_DATA}/reset`) {
    state = undefined;
  }
  return getAllQAList(state, action)
}
export const StandAloneBotWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SATNDALONE_BOT}/reset`) {
    state = undefined;
  }
  return StandAloneBot(state, action);
};
export const KnowledgeBaseWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.KNOWLEDGEBASE}/reset`) {
    state = undefined;
  }
  return knowledgeBaseTab(state, action);
};

export const ConnectorsWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CONNECTORS}/reset`) {
    state = undefined;
  }
  return connectorSlice(state, action);
};

export const LiveTrackerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.LIVE_TRACKER}/reset`) {
    state = undefined;
  }
  return liveTracker(state, action);
};

export const ApiIntegrationWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.APIINTEGRATION}/reset`) {
    state = undefined;
  }
  return apiIntegration_slice(state, action);
};

export const callConfigWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.APIINTEGRATION}/reset`) {
    state = undefined;
  }
  return callConfig(state, action);
};

export const WhatsppConfigWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.WHATSAPP_CONFIG}/reset`) {
    state = undefined;
  }
  return whatsapp_config(state, action);
};

export const FacebookConfigWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.WHATSAPP_CONFIG}/reset`) {
    state = undefined;
  }
  return facebook_config(state, action);
};


export const SocialmediaWidgetWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SOCIALMEDIA_WIDGET}/reset`) {
    state = undefined;
  }
  return socialmediaWidget(state, action);
};

export const MediaDeviceWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.MEDIA_INFO}/reset`) {
    state = undefined;
  }
  return mediaslice(state, action);
};

export const ScreenShareWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.SCREENSHARE_INFO}/reset`) {
    state = undefined;
  }
  return screenshare(state, action);
};

export const CustomerSatisfactionReducerWrapper =(state:any,action:any) =>{
  if(action.type ===`${Helper.CUSTOMER_SATISFACTON}/reset`){
    state = undefined;
  }
  return CustomerSatisfactionReducer(state, action);
}

export const DynamicdDashboardReducerWrapper =(state:any,action:any) =>{
  if(action.type ===`${Helper.DYNAMIC_DASHBOARD}/reset`){
    state = undefined;
  }
  return DynamicdDashboardReducer(state, action);
}
export const OutboundCampaignWrapper =(state:any,action:any) =>{
  if(action.type ===`${Helper.OUTBOUND_CAMPAIGN}/reset`){
    state = undefined;
  }
  return OutboundCampaignReducer(state, action);
}

